import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";
import axiosInstance from "../axiosInstance";

export interface OtherBranchData {
    order_idx: number;
    member_idx: number;
    order_number: string;
    delivery_date: string;
    order_status: number;
    order_status_text: string;
    is_printed: boolean;
    customer_manager_name: string;
    excel_date: string;
    customer_idx: number;
    customer_name: string;
    order_name: string;
    order_mobile: string;
    product_category: string;
    product_name: string;
    delivery_address: string;
    delivery_address_detail: string;
    sales_amount: number;
    order_amount: number;
    payment_amount: number;
    pending_amount: number;
    recipient_name: string;
    wreath_sender: string;
    branch_type: number;
    branch_name: string;
    payment_status: number;
    payment_status_text: string;
    branch_payment_status: number;
    branch_payment_status_text: string;
    order_date: string;
    event_content: {
        event_content_idx: number;
        depth1_idx: number;
        depth1: string;
        depth2: string | null;
        event_content: string;
    };
}

interface GetOtherBranchResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: OtherBranchData[];
}

interface GetOtherBranchParams {
    page: number;
    searchtxt?: string;
    field?: string;
    direction?: string;
    startDate?: Date;
    endDate?: Date;
    status: number;
}

export const useGetOtherBranchCustomerList = (
    customerIdx: number,
    params: GetOtherBranchParams,
): UseQueryResult<GetOtherBranchResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetOtherBranchResponse, Error>({
        queryKey: ["getOtherBranchCustomerList", params],
        queryFn: async () => {
            const response = await axiosInstance.get(`${enum_api_uri.get_settlements}/${customerIdx}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    page: params.page,
                    search: "order_name",
                    searchtxt: params.searchtxt,
                    field: params.field,
                    direction: params.direction,
                    start_date: params.startDate ? params.startDate.toISOString().split("T")[0] : undefined,
                    end_date: params.endDate ? params.endDate.toISOString().split("T")[0] : undefined,
                    ...(params.status === 0 ? {} : { branch_payment_status: params.status }),
                },
            });
            return response.data.data;
        },
        placeholderData: prevData => {
            if (prevData) {
                return {
                    ...prevData,
                    current_page: params.page,
                };
            }
            return undefined;
        },
    });
};
